import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { AppConfigService } from '../../services/config/app-config.service';
import { CORS_WORKAROUND_TOKEN } from '../error/error.interceptor';

/**
 *  Hierdurch erfüllte AFOs:
 *
 * A_25483-01 - TI-M Client User-Agent
 */

export const orgAdminInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService);
  const config = inject(AppConfigService);
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.getAccessToken().pipe(
    switchMap(token => {
      if (!req.url.includes(config.get('authorityUrl')) && !req.url.includes(config.get('vzdFhirUrl')) && token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'X-TIM-User-Agent': `${environment.productTypeVersion}, ${environment.productVersion}, ${environment.productShortname}`
          }
        });
      }

      return handleAuthErrors(req, next, oidcSecurityService, router, snackbarService);
    })
  );
};

function handleAuthErrors(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  oidcSecurityService: OidcSecurityService,
  router: Router,
  snackbarService: SnackbarService
) {
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        return oidcSecurityService.forceRefreshSession().pipe(
          switchMap(() => next(req)),
          catchError(() => {
            router.navigate(['org-admin-login']);
            return throwError(() => err);
          })
        );
      }

      // Workaround TIME-2734: Remove when CORS problem for OrgAdminEndpointsService:changeDisplayname is fixed
      if (err.status === 0 && req.context.get(CORS_WORKAROUND_TOKEN)) {
        return throwError(() => err);
      }

      snackbarService.error(`Es ist ein Fehler aufgetreten: ${err.error?.errorMessage ?? err.message}`);

      return throwError(() => err);
    })
  );
}
